/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Payment,
  RecordPayment200,
  RecordPaymentRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List payments recorded on this invoice
 */
export const listPayments = (
    invoiceId: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Payment[]>(
      {url: `/api/v1/invoices/${invoiceId}/payments`, method: 'GET', signal
    },
      );
    }
  



export const getListPaymentsQueryKey = (invoiceId?: string,) => {
    return [
    `/api/v1/invoices/${invoiceId}/payments`
    ] as const;
    }

    
export const getListPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPaymentsQueryKey(invoiceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayments>>> = ({ signal }) => listPayments(invoiceId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(invoiceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof listPayments>>>
export type ListPaymentsQueryError = unknown


export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayments>>,
          TError,
          Awaited<ReturnType<typeof listPayments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayments>>,
          TError,
          Awaited<ReturnType<typeof listPayments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List payments recorded on this invoice
 */

export function useListPayments<TData = Awaited<ReturnType<typeof listPayments>>, TError = unknown>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPaymentsQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Record a payment — partner only; mirrors an independent row onto the client's invoice copy
 */
export const recordPayment = (
    invoiceId: string,
    recordPaymentRequest: RecordPaymentRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RecordPayment200>(
      {url: `/api/v1/invoices/${invoiceId}/payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordPaymentRequest, signal
    },
      );
    }
  


export const getRecordPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{invoiceId: string;data: RecordPaymentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{invoiceId: string;data: RecordPaymentRequest}, TContext> => {

const mutationKey = ['recordPayment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordPayment>>, {invoiceId: string;data: RecordPaymentRequest}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  recordPayment(invoiceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecordPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof recordPayment>>>
    export type RecordPaymentMutationBody = RecordPaymentRequest
    export type RecordPaymentMutationError = unknown

    /**
 * @summary Record a payment — partner only; mirrors an independent row onto the client's invoice copy
 */
export const useRecordPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordPayment>>, TError,{invoiceId: string;data: RecordPaymentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordPayment>>,
        TError,
        {invoiceId: string;data: RecordPaymentRequest},
        TContext
      > => {

      const mutationOptions = getRecordPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    